"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsUserInfo_1 = require("../../model/hsUserInfo");
var service_1 = require("../../../library/base/service");
var CenterInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CenterInit, _super);
    function CenterInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '个人中心初始化接口';
        _this.code = '105029';
        _this.desc = '个人中心初始化接口';
        _this.requestParams = new hsUserInfo_1.CenterInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CenterInit;
}(service_1.BaseService));
exports.CenterInit = CenterInit;
//# sourceMappingURL=centerInit.js.map